import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import LineGraph from '../../Graphs/LineGraph'

import PageSection from '../../PageSection'

import { formatSegmentLabels } from '../helpers'
import { getFormattedValue } from '../../../formatters'

import useStyles from '../styles'

const CTRGraph = ({ rawGraphData }) => {
  const classes = useStyles()

  const ctrGraphData = useMemo(
    () => rawGraphData && rawGraphData.data && rawGraphData.data.map(data => data.value),
    [rawGraphData]
  )
  const ctrGraphLabels = useMemo(() => formatSegmentLabels(rawGraphData), [rawGraphData])

  return (
    <PageSection className={classes.sectionContainer}>
      <div className={classes.headingContainer}>
        <div className={classes.title}>CTR</div>
        <div className={classes.value}>{getFormattedValue({ value: rawGraphData.total, type: 'ctr' })}</div>
      </div>
      <LineGraph className={classes.graphWrapper} data={ctrGraphData} labels={ctrGraphLabels} format="percentage" />
    </PageSection>
  )
}

CTRGraph.propTypes = {
  rawGraphData: PropTypes.object.isRequired
}

export default CTRGraph
